module.exports = __webpack_public_path__ + "static/media/dollar-sign-invert.2e85c2b5.svg";